import { InputArea } from "./styles";

interface INewButton {
  label: string;
  name: string;
  onChange: Function;
  width?: string;
  defaultValue?: string;
  type?: string;
}

export const FormInputText: React.FC<INewButton> = ({
  label,
  type,
  name,
  onChange,
  width,
  defaultValue,
  ...props
}) => {
  return (
    <InputArea width={width}>
      <label>{label}</label>
      <input
        type={type ?? "text"}
        onChange={(e) => onChange(e.target.value, name)}
        name={name}
        value={defaultValue}
      />
    </InputArea>
  );
};
